export const isClearTripDomain = (): boolean => {
    if (typeof window === 'undefined') return false
    const host = window.location.hostname.toLowerCase()
    return host.includes('cleartrip')
}

export default isClearTripDomain
